import { render } from "./OButton.vue?vue&type=template&id=c0982772&scoped=true"
import script from "./OButton.vue?vue&type=script&lang=js"
export * from "./OButton.vue?vue&type=script&lang=js"

import "./OButton.vue?vue&type=style&index=0&id=c0982772&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0982772"]])

export default __exports__